import ViewCad from "../../../view";
import { MeioPagViewProps } from "../meiopg.controll";
import { MeioPag } from "../meiopg.model";

interface MeioPagCadastroProps extends MeioPagViewProps {
    handleCloseView: () => any
}

export function MeioPagCadastro(props: MeioPagCadastroProps) {
    const { meioPagActions, meioPagState, handleCloseView } = props
    const { error, loading, msg, row, showAlert, showDialogExluir, status } = meioPagState
    const { create, read, update, deletar, set, get, setShowAlert, setShowDialogExluir, setClearValue } = meioPagActions

    const handleNovo = () => {
        setClearValue();
    }

    const handleExcluir = (row: MeioPag) => {
        deletar(row);
        setShowDialogExluir(false);
        handleCloseView();
    }

    const formValidate = (values: MeioPag) => {
        const errors: any = {}
        if (!values.descricao)
            errors.nome = "Informe a descrição do pagamento"
        return errors
    }

    const handleUpdate = (value: MeioPag) => {
        if (!value._rev) {
            create(value);
        } else {
            update(value);
        }
    }

    var viewCad = new ViewCad({
        formTitle: "Cadastro do Meio de Pagamento",
        formFieldDescription: "descricao",
        loading: loading,
        msg: msg,
        row: row,
        status: status,
        showAlert: showAlert,
        showDialogExluir: showDialogExluir,
        buttonNovo: {
            show: true,
            title: "Adicionar novo meio de pagamento",
            onClick: () => handleNovo(),
        },
        handleExcluir: handleExcluir,
        formValidate: formValidate,
        handleUpdate: handleUpdate,
        handleCloseAlert: () => setShowAlert(false),
        setShowDialogExluir: setShowDialogExluir,
        handleCloseView: () => handleCloseView(),
        contentForm: [
            { fieldName: "descricao", label: "Descrição", type: "text", key: "nome", colunsXS: 8, colunsSM: 8, colunsMD: 8, require: true },
            { fieldName: "perc_desc", label: "% Desconto", type: "number", key: "perc_desc", colunsXS: 4, colunsSM: 4, colunsMD: 4 },
            { fieldName: "show_movel", label: "Exibir App?", type: "checkbox", key: "show_movel", colunsXS: 6, colunsSM: 6, colunsMD: 6,  },
            { fieldName: "ativo", label: "Ativo?", type: "checkbox", key: "ativo", colunsXS: 6, colunsSM: 6, colunsMD: 6,  },
            { fieldName: "obs", label: "Observações", type: "text", key: "obs", colunsXS: 12, colunsSM: 12, colunsMD: 12 },
        ],
    })

    return viewCad
}



